
import { environment } from './../environments/environment';
import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmationService } from 'primeng/primeng';
import { AppComponent } from './app.component';
import { AuthenticationService } from './commons/servicos/authentication.service';
import { ControleDeEstoqueService } from './commons/servicos/controle-de-estoque.service';
import { DisponibilidadeRecursoService } from './commons/servicos/disponibilidade-recurso.service';
import { LogService } from './commons/servicos/log.service';
import { LoginService } from './commons/servicos/login.service';
import { SolicitacaoRecursoService } from './commons/servicos/solicitacao-recurso.service';
import { ConfirmDialogCsiComponent } from './commons/ui/confirm-dialog-csi/confirm-dialog-csi.component';
import { CanActivateAuthGuard } from './core/can-active.authguard';
import { Carregado } from './core/carregado';
import { CsiHttp } from './core/csi-http';
import { UserUtil } from './core/user-util';
import { WebsocketService } from './core/websocket-service.service';
import { HomeComponent } from './home/home.component';
import { RotasModule } from './modulos/rotas/rotas.module';
import { AgmCoreModule } from '@agm/core';
import { CanDeactivateGuardService } from './core/can-deactivate-guard.service';
import { AuthApiAlertaHttpService } from './commons/servicos/AuthApiAlertaHttp.service';
import { InputFloatComponent } from './commons/ui/input-float/input-float.component';
import { InputAutocompleteFloatComponent } from './commons/ui/input-autocomplete-float/input-autocomplete-float.component';
import { AvisosService } from './commons/servicos/avisos.service';
import { IntFormatDirective } from './commons/ui/inteiro-format/inteiro-format';







registerLocaleData(localePt, 'pt-BR');




@NgModule({
  declarations: [
    AppComponent,
    ConfirmDialogCsiComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule, NoopAnimationsModule, HttpClientModule, RotasModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  exports: [],
  providers: [HttpClient, CsiHttp, LogService, CanDeactivateGuardService,AvisosService,
    AuthenticationService, CanActivateAuthGuard, ConfirmationService, ControleDeEstoqueService, DisponibilidadeRecursoService,
    SolicitacaoRecursoService, Carregado, WebsocketService, UserUtil, LoginService, AuthApiAlertaHttpService,
    {provide: LOCALE_ID, useValue: 'pt-BR'}
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts